<template>
  <div>
    <div>
      <v-switch
        label="Use Share URL"
        class="mt-2"
        :input-value="settings.useShareUrl"
        @change="(val) => onUpdate(val, `settings.useShareUrl`)"
      ></v-switch>
      <mustache-template
        v-if="settings.useShareUrl"
        label="Share URL"
        class="mb-3"
        :value="settings.shareUrl"
        @input="(val) => onUpdate(val, `settings.shareUrl`)"
        :singleLine="true"
      />
      <v-autocomplete
        v-if="!settings.useShareUrl"
        class="mb-3"
        outlined
        dense
        :value="settings.location"
        @input="(val) => setLocation(val)"
        item-text="name"
        item-value="id"
        :items="driveFolders"
        label="File Location"
        @click:append-outer="listFolders"
        :append-outer-icon="loading ? 'mdi-loading mdi-spin' : 'mdi-reload'"
        clearable
      ></v-autocomplete>
      <v-text-field
        v-if="!settings.useShareUrl"
        outlined
        dense
        label="File Name"
        hide-details="auto"
        type="text"
        class="mb-3"
        :value="settings.locationName"
        @input="(val) => onUpdate(val, 'settings.locationName')"
      ></v-text-field>
      <mustache-template
        label="Action and File Description for AI"
        class="mr-2"
        :value="settings.overrideDescription"
        @input="(val) => onUpdate(val, `settings.overrideDescription`)"
        :suggestions="[]"
        :singleLine="false"
      />
    </div>
  </div>
</template>

<script>
import MustacheTemplate from '@/components/mustache/mustache-template.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: worklfowActions } =
  createNamespacedHelpers('workflows/list');
const { mapGetters: workspacesGetters } =
  createNamespacedHelpers('aiWorkspace');

export default {
  name: 'OneDriveFileAccess',
  components: { MustacheTemplate },
  props: {},
  data() {
    return {
      driveFolders: [],
      loading: false,
    };
  },
  computed: {
    ...workspacesGetters({
      selectedAction: 'SELECTED_ACTION',
      generalActions: 'WORKSPACE_GENERAL_ACTIONS',
    }),
    settings() {
      return this.selectedAction.settings;
    },
    action() {
      return this.selectedAction.action_type;
    },
    suite() {
      return 'outlook';
    },
  },
  created() {
    if (!this.settings.location || !this.settings.locationName) {
      return;
    }
    this.driveFolders.push({
      id: this.settings.location,
      name: this.settings.locationName,
    });
  },
  methods: {
    ...worklfowActions(['outlookAction']),
    setLocation(location) {
      this.onUpdate(location, 'settings.location');
      const folder = this.driveFolders.find((item) => item.id === location);
      if (folder?.name) {
        this.onUpdate(folder.name, 'settings.locationName');
        this.onUpdate(folder.driveId, 'settings.driveId');
      } else {
        this.onUpdate(null, 'settings.locationName');
        this.onUpdate(null, 'settings.driveId');
      }
    },
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
    suiteAction(data) {
      return this.outlookAction(data);
    },
    async listFolders() {
      if (!this.settings.authenticationId) {
        return;
      }
      this.loading = true;
      try {
        const data = {
          authenticationId: this.settings.authenticationId,
          action: 'list_folders',
        };
        const resp = await this.suiteAction(data);

        if (resp && resp.result) {
          this.driveFolders = resp.result;
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
